import React from 'react';
import { format } from 'date-fns';

import HistoryInterface from '../../../../interfaces/history';

import Subtitle from '../../../ui/Subtitle';
import Text from '../../../ui/Text';

import * as Styles from './HistoryStyles';

interface Props {
  error: boolean;
  loading: boolean;
  items: HistoryInterface[];
  getItemById: Function;
}

const History: React.FC<Props> = ({
  error,
  loading,
  items,
  getItemById,
}: Props) => {
  const actionMapping = {
    dispensed: 'dispensado',
    'canceled-dispensation': 'cancelado',
  };
  const hasItems = items.length;

  return (
    <>
      <Subtitle>Histórico de dispensação</Subtitle>
      <Styles.Table>
        <thead>
          <tr>
            <th style={{ padding: '16px 0px 16px 16px' }}>Data/Hora</th>
            <th>Item</th>
            <th>Qtd.</th>
            <th>Usuário</th>
            <th>Drogaria</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={5}>
                <Text align='center' color='black'>
                  Carregando...
                </Text>
              </td>
            </tr>
          )}
          {error && (
            <tr>
              <td colSpan={5}>
                <Text align='center' color='red'>
                  Erro ao carregar histórico.
                </Text>
              </td>
            </tr>
          )}
          {!loading && !error && !hasItems && (
            <tr>
              <td colSpan={5}>
                <Text align='center' color='black'>
                  Nenhum item dispensado ainda.
                </Text>
              </td>
            </tr>
          )}

          {items.map((item: HistoryInterface) => (
            <tr key={item.id} style={{ marginBottom: '16px', }}>
              <td style={{ padding: '16px 0px 16px 16px' }}>
                {format(item.date, 'dd/MM/yyyy HH:mm:ss')}
              </td>
              <td>
                {getItemById(item.itemId) ? getItemById(item.itemId).name : ''}
              </td>
              <td>{item.quantity || '-'}</td>
              <td>{item.user.name}</td>
              <td>{item.drugstore.name}</td>
              <td>
                <Styles.Status status={item.action}>
                  {actionMapping[item.action]}
                </Styles.Status>
              </td>
            </tr>
          ))}
        </tbody>
      </Styles.Table>
    </>
  );
};

export default History;
